import React, { useCallback } from 'react';

import { stringify } from 'qs';
import { TableContentWrapper } from './styles';

import LoadingSpinning from '../../molecules/LoadingSpinning';

import EmptyContent from './EmptyContent';
import DocumentosBeneficiarios from './DocumentosBeneficiarios';

function TableDocumentos({
  idLista,
  headers,
  beneficiarios,
  loading,
  handleModalDetalheDocumento,

  pageData,
  paginationParams,
  handleChangePage,
  setPaginationParams,
  handlePageChangeKeyDown,
  hasPagination = true,
}) {
  if (loading) {
    return (
      <TableContentWrapper>
        <LoadingSpinning height="250px" />;
      </TableContentWrapper>
    );
  }

  if (!headers || headers.length <= 0) {
    return <EmptyContent />;
  }

  return (
    <DocumentosBeneficiarios
      idLista={idLista}
      headers={headers}
      filteredBeneficiarios={beneficiarios}
      handleModalDetalheDocumento={handleModalDetalheDocumento}
      pageData={pageData}
      paginationParams={paginationParams}
      handleChangePage={handleChangePage}
      setPaginationParams={setPaginationParams}
      handlePageChangeKeyDown={handlePageChangeKeyDown}
      hasPagination={hasPagination}
    />
  );
}

export default TableDocumentos;
